export enum MAJOR_APP_ERROR {
  UNHANDLED_ERROR = 'An unknown or unhandled error occurred',
  EXPIRED_JOURNEY_TOKEN = 'Journey token has expired',
  INVALID_JOURNEY_TOKEN = 'Journey token is invalid'
}
